export const MessageTypeEnumValue = {
  Success: 'success',
  Info: 'info',
  Warning: 'warning',
  Danger: 'error',
};
